export const sumoPracticeProducts = [
  { id: "152592f3-9507-430b-a717-7483840a59d9", name: "Ryogoku" },
  { id: "4d45bef3-3120-408d-85f4-7d6ca585b9af", name: "Oshiage" },
  { id: "54ea71a7-f928-496f-9a43-e50d17a2f585", name: "Kiyosumi-Shirakawa" },
] as const;

export const sumoPracticeProductIds = sumoPracticeProducts.map(({ id }) => id);

export function isSumoPracticeProductId(
  id: string
): id is (typeof sumoPracticeProductIds)[number] {
  return (sumoPracticeProductIds as readonly string[]).includes(id);
}

export const photographyProductIds = [
  "13982922-8e17-49c8-b590-561e2caae7fe",
  "9f0a5d04-fa70-4a25-82e5-36eca32ec5d5",
] as const;

export function isPhotographyProductId(
  id: string
): id is (typeof photographyProductIds)[number] {
  return (photographyProductIds as readonly string[]).includes(id);
}
